// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* BORDERS */\n\n/* Icons */\n\n/* BORDERS */\n\n/* Icons */\n.input-new-floor[data-v-7a92b236]  .v-input__append-inner .v-btn {\n  margin-top: -6px !important;\n}", ""]);
// Exports
module.exports = exports;
